import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

const headers = new HttpHeaders()
.set('content-type', 'application/json');

@Injectable({
  providedIn: 'root',
})
export class GeneralHttpService {
  constructor(public http: HttpClient) {}

  get<T>(url: string, params?: HttpParams): Observable<T> {
    return this.http.get<T>(url, { params });
  }

  post<T>(url: string, body?: any, params?: HttpParams): Observable<T> {
    console.log(headers);
    return this.http.post<T>(url, JSON.stringify(body), { headers , params });
  }

  put<T>(url: string, body: any, params?: HttpParams): Observable<T> {
    return this.http.put<T>(url, body, { params });
  }
  delete<T>(url: string, params?: HttpParams): Observable<T> {
    return this.http.delete<T>(url, { params });
  }
}
